/**
 * MANAGEMENT (14) · Pricing + billing formatting/tone helpers. Money is integer CENTIMES on the wire — we
 * REUSE the finance money helpers verbatim (reuse over reinvent, L-5) rather than re-derive the
 * centimes↔display conversion. Tone mappers live here (not in a screen) so the pricing table + the billing
 * panel share them without tripping the react-refresh single-export rule.
 */
import type { BadgeTone } from "@/ui";
import type { PaymentStatut } from "./pricing.types";

// Re-use the finance centimes helpers (the same integer-centimes convention the whole app speaks).
export {
  CURRENCY,
  formatCentimes,
  parseToCentimes,
  centimesToEditable,
} from "@/features/finance/money";

/**
 * Badge tone per SubscriptionPayment statut: paye → success · en_attente → warn · echec → danger. Mirrors
 * the app's tone vocabulary so the billing table reads consistently with the rest of the console.
 */
export function paymentStatutTone(statut: PaymentStatut | null | undefined): BadgeTone {
  switch (statut) {
    case "paye":
      return "success";
    case "en_attente":
      return "warn";
    case "echec":
      return "danger";
    default:
      return "neutral";
  }
}

/** "lis, facturation ,, qc" → ["lis","facturation","qc"] (trim + drop blanks; the server stores verbatim). */
export function splitCsv(raw: string): string[] {
  return raw
    .split(",")
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
}
